import React, { useState } from "react";
import { SFIncludeCheckbox } from "@sf-core";

const IncludeCheckbox = () => {
  const [checked, setChecked] = useState(false);

  return (
    <SFIncludeCheckbox
      checked={checked}
      onChange={() => setChecked((prevVal) => !prevVal)}
    />
  );
};

export default IncludeCheckbox;
